import { Flex, IconButton } from '@homebotapp/hb-react-component-catalog'
import { useDispatch, useSelector } from 'react-redux'
import { selectClientIsGuest } from '../../../store/selectors/client'
import { IconHeart, IconHeartEmpty } from '../../shared/Icon'
import { useGetFavoriteListings } from '../../../hooks/gallery/useGetFavoriteListings'
import { useMemo } from 'react'
import { useToggleFavoriteListing } from '../../../hooks/listings/useToggleFavoriteListing'
import { isAuthTokenSupported } from '../../../auth'
import { toggleAuthModal } from '../../../actions/homeSearchAuthModal'

export interface ListingFavoriteBtnProps {
  listingId: string
}

export const ListingFavoriteBtn = ({ listingId }: ListingFavoriteBtnProps) => {
  const isGuest = useSelector(selectClientIsGuest)

  const { data, refetch } = useGetFavoriteListings()
  const favoriteListings = useMemo(() => data?.favoriteListings?.listings ?? [], [data?.favoriteListings?.listings])

  const { mutateAsync: toggleFavoriteListing, isLoading } = useToggleFavoriteListing()
  const dispatch = useDispatch()

  const isFavorite = useMemo(() => {
    return favoriteListings.some(listing => listing?.id === listingId)
  }, [favoriteListings, listingId])

  const handleFavoriteClick = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    e.stopPropagation()
    if (!isAuthTokenSupported() || isGuest) {
      dispatch(toggleAuthModal(true))
      return
    }
    await toggleFavoriteListing({ listingId })
    refetch()
  }

  if (isGuest) {
    return null
  }

  return (
    <Flex alignItems='center'>
      {!isLoading && (
        <IconButton
          variant='outline'
          colorScheme='secondary'
          aria-label='Like this listing'
          onClick={handleFavoriteClick}
          icon={isFavorite ? <IconHeart className='brand' /> : <IconHeartEmpty />}
        />
      )}
    </Flex>
  )
}
